<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="frontmatter-rw TitlePage-rw exclude-print-rw" epub:type="frontmatter titlepage" id="BookTitlePage1">
<h1 class="title">The Breaking Point</h1>
<h1 class="title1">Stories</h1>
<h1 class="title2">Daphne du Maurier</h1>
<h1 class="title3">Foreword by Sally Beauman </h1>
<p class="img"><img alt="images" src="images/Little_full.jpg"/></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// titlepage.vue?6ee92382